export const DefaultReportArray = {
	Performance_Summary: {
		Performance_Summary_Total: {
			title: "Comparison Summaries",
			customizable: true,
			reportIds: [1, 8],
			compReports: {
				curr: "Performance_Summary_current",
				prev: "Performance_Summary_previous",
			},
			inReport: true,
			reportType: "verticalComp",
			sortBy: "selectedTime",
			position: "start",
			limit: 3,
			titleDisplay: "Performance Summary",
			headers: [
				{
					value: "selectedTime",
					format: "string",
					label: "Compared Dates",
					comp: false,
					addClass: "",
				},
				{
					value: "Sales",
					format: "dollar",
					label: "Sales",
					comp: true,
					addClass: "",
				},
				{
					value: "Click Throughs",
					format: "int",
					label: "Clicks",
					comp: true,
					addClass: "",
				},
				{
					value: "# of Sales",
					format: "int",
					label: "# of Sales",
					comp: true,
					addClass: "",
				},
				{
					value: "Average Sale Amount",
					format: "dollar",
					label: "Average Sale Amount",
					comp: true,
					addClass: "",
				},
				{
					value: "Conversion Rate",
					format: "percent",
					label: "Conversion Rate",
					comp: true,
					addClass: "",
				},
				{
					value: "New Customer %",
					format: "percent",
					label: "New Customer %",
					comp: true,
					addClass: "",
				},
				{
					value: "Mobile Sales",
					format: "dollar",
					label: "Mobile Sales",
					comp: true,
					addClass: "",
				},
			],
		},
	},
	Timeline_Graphs: {
		Performance_Summary_By_Day_Graph: {
			ids: [12],
			inReport: true,
			customizable: false,
			compReports: {
				curr: "Performance_Summary_By_Day_current",
				prev: "Performance_Summary_By_Day_previous",
			},
			reportType: "graph",
			titleDisplay: "Performance Summary By Day",
			hAxisTitle: "Day",
			headers: [
				{ value: "Sales", label: "Sales", format: "currency" },

				{
					value: "Conversion Rate",
					label: "Conversion Rate",
					format: "percent",
				},
			],
		},
		Performance_Summary_By_Month_Graph: {
			ids: [48],
			inReport: true,
			customizable: false,
			compReports: {
				curr: "Performance_Summary_By_Month_current",
				prev: "Performance_Summary_By_Month_previous",
			},
			reportType: "graph",
			titleDisplay: "YTD Summary By Month",
			hAxisTitle: "Month",
			headers: [
				{ value: "Sales", label: "Sales", format: "currency" },

				{
					value: "Conversion Rate",
					label: "Conversion Rate",
					format: "percent",
				},
			],
		},
	},

	Product_Performance: {
		Product_Sold_List: {
			customizable: false,
			reportIds: 18,
			inReport: true,
			sortBy: "Total Product Sale Quantity",
			joinKey: "Product Name",
			titleDisplay: "",
			headers: [
				{
					label: "Product Name",
					format: "string",
					value: "Product Name",
				},
				{
					label: "Product SKU",
					format: "string",
					value: "Product SKU",
				},
				{
					label: "Sale Count ",
					format: "int",
					value: "Sale Count ",
				},
				{
					label: "Total Product Sale Amount",
					format: "dollar",
					value: "Total Product Sale Amount",
				},
			],
		},

		Product_Performance_By_Departments_and_Brands: {
			customizable: false,
			reportIds: 18,
			inReport: true,
			sortBy: "Total Product Sale Quantity",
			joinKey: "Product Name",
			titleDisplay: "",
			headers: [
				{
					label: "Product Name",
					format: "string",
					value: "Product Name",
				},
				{
					label: "Product SKU",
					format: "string",
					value: "Product SKU",
				},
				{
					label: "Sale Count ",
					format: "int",
					value: "Sale Count ",
				},
				{
					label: "Total Product Sale Amount",
					format: "dollar",
					value: "Total Product Sale Amount",
				},
				{
					value: "Brand Name",
					format: "string",
					label: "Brand Name",
				},
				{
					value: "Category",
					format: "string",
					label: "Category",
				},
				{
					value: "Department",
					format: "string",
					label: "Department",
				},
				{
					value: "Merchant",
					format: "string",
					label: "Merchant",
				},
				{
					value: "Sub Category",
					format: "string",
					label: "Sub Category",
				},
				{
					value: "Total Product Sale Amount",
					format: "dollar",
					label: "Total Product Sale Amount",
				},
				{
					value: "Total Product Sale Quantity",
					format: "int",
					label: "Total Product Sale Quantity",
				},
			],
		},
	},
	Affiliate_Performance_Reports: {
		Performance_Summary_By_Affiliate: {
			reportIds: [15],
			compReports: {
				curr: "Performance_Summary_By_Affiliate_current",
				prev: "Performance_Summary_By_Affiliate_previous",
			},
			inReport: true,
			reportType: "horizontalComp",
			sortBy: "Sales",
			joinKey: "Affiliate Id",
			position: "flex",
			customizable: true,
			titleDisplay: "Performance Summary by Affiliate",
			headers: [
				{
					value: "Affiliate Name",
					format: "string",
					label: "Affiliate Name",
					comp: false,
					addClass: "",
				},
				{
					value: "Click Throughs",
					format: "int",
					label: "Click Throughs",
					comp: true,
					addClass: "small-cell",
				},
				{
					value: "Sales",
					format: "dollar",
					label: "Sales",
					comp: true,
					addClass: "small-cell",
				},

				{
					value: "# of Sales",
					format: "int",
					label: "# of Sales",
					comp: true,
					addClass: "small-cell",
				},

				{
					value: "Commissions",
					format: "dollar",
					label: "Commissions",
					comp: true,
					addClass: "small-cell",
				},
				{
					value: "Conversion Rate",
					format: "percent",
					label: "Conversion Rate",
					comp: true,
					addClass: "small-cell",
				},
				{
					addClass: "small-cell",
					comp: true,
					label: "AOV",
					format: "dollar",
					value: "Average Sale Amount",
				},
				{
					value: "Total Spend",
					format: "dollar",
					label: "Total Spend",
					comp: true,
					addClass: "small-cell",
				},
				{
					value: "ROA",
					format: "dollar",
					label: "ROA",
					comp: true,
					addClass: "small-cell",
				},
			],
		},
		Performance_Summary_By_Affiliate_Website: {
			reportIds: [20],
			compReports: {
				curr: "Performance_Summary_By_Affiliate_Website_current",
				prev: "Performance_Summary_By_Affiliate_Website_previous",
			},
			inReport: true,
			reportType: "horizontalComp",
			sortBy: "Sales",
			joinKey: "Affiliate Id",
			position: "flex",
			customizable: true,
			titleDisplay: "Performance Summary By Affiliate Website",
			headers: [
				{
					value: "Affiliate Website Name",
					format: "string",
					label: "Affiliate Website Name",
					comp: false,
					addClass: "name-cell",
				},
				{
					value: "Affiliate Id",
					format: "string",
					label: "Affiliate Id",
					comp: false,
					addClass: "name-cell border-right",
				},
				{
					value: "Click Throughs",
					format: "int",
					label: "Click Throughs",
					comp: true,
					addClass: "small-cell",
				},
				{
					value: "Sales",
					format: "dollar",
					label: "Sales",
					comp: true,
					addClass: "small-cell",
				},

				{
					value: "# of Sales",
					format: "int",
					label: "# of Sales",
					comp: true,
					addClass: "small-cell",
				},

				{
					value: "Commissions",
					format: "dollar",
					label: "Commissions",
					comp: true,
					addClass: "small-cell",
				},
				{
					value: "Conversion Rate",
					format: "percent",
					label: "Conversion Rate",
					comp: true,
					addClass: "small-cell",
				},
				{
					value: "AOV",
					format: "dollar",
					label: "AOV",
					comp: true,
					addClass: "small-cell",
				},
				{
					value: "Total Spend",
					format: "dollar",
					label: "Total Spend",
					comp: true,
					addClass: "small-cell",
				},
				{
					value: "ROA",
					format: "dollar",
					label: "ROA",
					comp: true,
					addClass: "small-cell",
				},
			],
		},
		Performance_Summary_By_Sub_Affiliate_Partner: {
			reportIds: [96],
			compReports: {
				curr: "Performance_Summary_By_Sub_Affiliate_Partners_current",
				prev: "Performance_Summary_By_Sub_Affiliate_Partners_previous",
			},
			inReport: true,
			customizable: true,
			reportType: "horizontalComp",
			sortBy: "Sales",
			joinKey: "Affiliate Id",
			position: "flex",
			titleDisplay: "Performance Summary by Sub Affiliate Partner",
			headers: [
				{
					value: "Sub Affiliate Domain",
					format: "string",
					label: "Sub Affiliate Domain",
					comp: false,
					addClass: "name-cell",
				},
				{
					value: "Affiliate Name",
					format: "string",
					label: "Affiliate Name",
					comp: false,
					addClass: "border-right",
				},
				{
					value: "Click Throughs",
					format: "int",
					label: "Click Throughs",
					comp: true,
					addClass: "small-cell",
				},
				{
					value: "Sales",
					format: "dollar",
					label: "Sales",
					comp: true,
					addClass: "small-cell",
				},

				{
					value: "# of Sales",
					format: "int",
					label: "# of Sales",
					comp: true,
					addClass: "small-cell",
				},

				{
					value: "Commissions",
					format: "dollar",
					label: "Commissions",
					comp: true,
					addClass: "small-cell",
				},
				{
					value: "Conversion Rate",
					format: "percent",
					label: "Conversion Rate",
					comp: true,
					addClass: "small-cell",
				},
				{
					value: "AOV",
					format: "dollar",
					label: "AOV",
					comp: true,
					addClass: "small-cell",
				},
				{
					value: "Total Spend",
					format: "dollar",
					label: "Total Spend",
					comp: true,
					addClass: "small-cell",
				},
				{
					value: "ROA",
					format: "dollar",
					label: "ROA",
					comp: true,
					addClass: "small-cell",
				},
			],
		},
	},
};
